import i18n from '@boot/i18n';
import { defaultUserModel } from '@const/defaultUserModel';

export function updateUser(state, user) {
  state.user = {
    ...defaultUserModel,
    ...state.user,
    ...user,
  };
}

export function setLocale(state, newLocale) {
  state.user.lang = newLocale || 'en-US';
  i18n.locale = newLocale || 'en-US';
}

export function updateTodayTasks(state, { tasks, count }) {
  state.todayTasks = tasks;
  state.todayTasksCount = count;
}

export function updateListTypes(state, listTypes) {
  state.listTypes = listTypes;
}

export function updateUnsavedDataProtection(state, value) {
  state.unsavedDataProtection = value;
}

export function setSendMeCopy(state, status) {
  state.sendMeCopy = status;
}

export function setDrawerOpen(state, open) {
  state.drawerOpen = open;
}

export function setLastCaseType(state, value) {
  state.lastCaseType = value;
}
